module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-left-down-c3dcab52b3e8c0b4b69b318bb097371f.svg";